function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M884.71,106.08H782.23V53.9a30.26,30.26,0,1,0-60.52,0V106H278.29V53.9a30.26,30.26,0,0,0-60.52,0V106H115.29A115.52,115.52,0,0,0,0,221.37v639.7A115.56,115.56,0,0,0,115.29,976.36H884.71A115.56,115.56,0,0,0,1000,861.07V221.37A115.56,115.56,0,0,0,884.71,106.08ZM226.47,289.56a30.12,30.12,0,0,0,21.5,9H248a30.28,30.28,0,0,0,30.2-30.29V166.66H721.65V268.23a30.26,30.26,0,0,0,60.52,0V166.66H884.59a54.81,54.81,0,0,1,54.71,54.77V393.27H60.58V221.4a54.83,54.83,0,0,1,54.71-54.74H217.71V268.17A30.29,30.29,0,0,0,226.47,289.56ZM939.42,453.68V861.07a54.8,54.8,0,0,1-54.71,54.71H115.29a54.8,54.8,0,0,1-54.71-54.71V453.68Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M438,778.69a30.45,30.45,0,0,0,42.36.47L673.52,594.47a30.31,30.31,0,0,0,1-42.83,30,30,0,0,0-21.21-9.35c-5.53-.7-10.87,1.21-15.57,3.88l-.94-.62-177,169.21-84-84a30.33,30.33,0,0,0-42.9,42.89Z"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ab9d29b4.svg";
export { ForwardRef as ReactComponent };